const wishlistToastManager = new ToastNotificationManager();

// Add this at the very beginning of the file, after the ToastNotificationManager line
function ensureWishlistInitialized() {
  if (!window.theme) {
    window.theme = {};
  }
  if (!window.theme.wishlistProductIds) {
    window.theme.wishlistProductIds = new Set();

    // Try to load from localStorage
    try {
      const storedJSON = localStorage.getItem("customerWishlist");
      const wishlistData = storedJSON ? JSON.parse(storedJSON) : null;
      const productIds =
        wishlistData?.wishlist?.products.map((p) => p.productId) || [];
      window.theme.wishlistProductIds = new Set(productIds);
      updateAllWishlistButtons();
    } catch (e) {
      console.error("Could not parse wishlist from local storage.", e);
    }
  }
}

// Call it immediately
ensureWishlistInitialized();

window.updateStateFromApiResponse = function (apiResult) {
  if (!apiResult || !Array.isArray(apiResult.wishlist)) return;

  const productIds = apiResult.wishlist.map((p) => p.productId);
  window.theme.wishlistProductIds = new Set(productIds);

  const dataToStore = {
    wishlist: {
      products: apiResult.wishlist,
    },
  };
  localStorage.setItem("customerWishlist", JSON.stringify(dataToStore));
};

async function addToWishlist(productId) {
  const response = await fetch(`/apps/${APP_SUB_PATH}/customer/wishlist/add`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ productId }),
  });
  const result = await response.json();
  if (result.success) {
    wishlistToastManager.show("Added to wishlist", "success");
  } else if (result.alreadyExists) {
    wishlistToastManager.show("Already in wishlist", "success");
  } else {
    wishlistToastManager.show("Failed to add to wishlist", "error");
  }
  return result;
}

// This function also only requires productId
async function removeFromWishlist(productId) {
  try {
    const response = await fetch(
      `/apps/${APP_SUB_PATH}/customer/wishlist/remove`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ productId }),
      }
    );
    const result = await response.json();
    if (!result.success) {
      wishlistToastManager.show("Failed to remove from wishlist", "error");
    }
    return result;
  } catch (error) {
    console.error("Remove from wishlist failed:", error);
    wishlistToastManager.show("An error occurred. Please try again.", "error");
    return null;
  }
}

// Fetch wishlist from API and update localStorage
async function fetchWishlistFromApi() {
  const wishlistStorageKey = 'customerWishlist';
  
  try {
    const response = await fetch(`/apps/${APP_SUB_PATH}/customer/wishlist/fetch`);
    if (!response.ok) throw new Error('API response was not ok.');

    const wishlistData = await response.json();
    
    // Update localStorage with fresh data
    localStorage.setItem(wishlistStorageKey, JSON.stringify(wishlistData));
    
    // Update the global wishlist state
    const productIds = wishlistData?.wishlist?.products.map((p) => p.productId) || [];
    if (!window.theme) window.theme = {};
    window.theme.wishlistProductIds = new Set(productIds);
    
    // Update all wishlist buttons across the page
    updateAllWishlistButtons();
    
    return { success: true, wishlistData, productIds };
  } catch (error) {
    console.error('Failed to fetch wishlist from API:', error);
    return { success: false, error };
  }
}

async function removeFromCart(lineIndex) {
  try {
    const body = JSON.stringify({
      line: lineIndex,
      quantity: 0,
    });
    const response = await fetch(window.theme.routes.cartChange, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: body,
    });
    const result = await response.json();
    if (response.ok) {
      updateCartCount();
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.refresh();
      }
      const cartPage = document.querySelector("cart-page");
      if (cartPage) {
        window.location.reload();
      }
      return { success: true, result };
    } else {
      throw new Error("Failed to remove from cart");
    }
  } catch (error) {
    console.error("Remove from cart failed:", error);
    return { success: false, error };
  }
}

function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountElements = document.querySelectorAll("[data-cart-count]");
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count;
        element.classList.toggle("hidden", cart.item_count === 0);
      });
    })
    .catch((e) => console.error("Error updating cart count:", e));
}

function updateAllWishlistButtons() {
  const wishlist = window.theme?.wishlistProductIds || new Set();
  const allButtons = document.querySelectorAll(
    ".wishlist-btn[data-product-id]"
  );

  allButtons.forEach((button) => {
    const productId = button.dataset.productId;
    const iconDefault = button.querySelector(".wishlist-icon-default");
    const iconActive = button.querySelector(".wishlist-icon-active");
    if (!iconDefault || !iconActive) return;

    if (wishlist.has(productId)) {
      iconDefault.classList.add("hidden");
      iconActive.classList.remove("hidden");
    } else {
      iconDefault.classList.remove("hidden");
      iconActive.classList.add("hidden");
    }
  });
}

function getCartItemLineIndex(button) {
  const cartItem = button.closest(".cart-drawer__item, .cart-page__item");
  if (!cartItem) return null;
  const itemId = cartItem.id;
  const match = itemId.match(/Cart(?:Drawer-)?Item-(\d+)/);
  return match ? match[1] : null;
}

function isInCartDrawer(button) {
  return button.closest("cart-drawer") !== null;
}

function isInCartPage(button) {
  return button.closest("cart-page") !== null;
}

document.addEventListener("DOMContentLoaded", function () {
  ensureWishlistInitialized();

  document.addEventListener("click", async (e) => {
    const button = e.target.closest(".wishlist-btn");
    if (!button) return;

    // Always stop propagation to prevent zoom trigger
    e.stopPropagation();

    // If it's a link (logged out user), let it navigate to login page
    if (button.tagName === 'A') {
      return;
    }

    // For buttons (logged in users), prevent default and handle wishlist logic
    e.preventDefault();
    const productId = button.dataset.productId;

    if (!productId) {
      console.error("Product ID not found for button:", button);
      return;
    }

    ensureWishlistInitialized();

    button.disabled = true;

    try {
      if (isInCartDrawer(button) || isInCartPage(button)) {
        const result = await addToWishlist(productId);
        if (result && (result.success || result.alreadyExists)) {
          updateStateFromApiResponse(result);
          const lineIndex = getCartItemLineIndex(button);
          if (lineIndex) {
            const cartRemoveResult = await removeFromCart(lineIndex);
            if (cartRemoveResult.success) {
              wishlistToastManager.show("Moved to wishlist", "success");
            } else {
              wishlistToastManager.show(
                "Added to wishlist, but failed to remove from cart",
                "warning"
              );
            }
          } else {
            console.warn("Could not find cart line index for item");
          }
        }
      } else {
        if (window.theme.wishlistProductIds.has(productId)) {
          const result = await removeFromWishlist(productId);
          if (result && result.success) {
            updateStateFromApiResponse(result);
            wishlistToastManager.show(
              "Product removed from wishlist",
              "success"
            );
          }
        } else {
          const result = await addToWishlist(productId);
          if (result && (result.success || result.alreadyExists)) {
            updateStateFromApiResponse(result);
          }
        }
      }
    } catch (error) {
      console.error("Wishlist action failed:", error);
      wishlistToastManager.show(
        "Something went wrong. Please try again.",
        "error"
      );
    } finally {
      updateAllWishlistButtons();
      button.disabled = false;
    }
  });
});
